// extracted by mini-css-extract-plugin
export default {"noDataText":"ProductExpireSearchResults_noDataText__g2sUf"};